import SpaceAvatar from '@/components/SpaceAvatar';
import { useSpace } from '@/contexts/SpaceContext';
import { useSpaceList } from '@/hooks/useSpace';
import Authorization from '@/modules/authentication/services/Auth.api.service';
import { CaretRightOutlined } from '@ant-design/icons';
import { Dropdown, Input, Menu, Empty} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import style from './index.less';
import { useResponsive } from '@/contexts/ResponsiveContext';

const HeaderMenu = ({mini}) => {
  const {t} = useTranslation('common');
  const {space, refetch} = useSpace();
  const {data, isLoading} = useSpaceList();
  const [spaceList, setSpaceList] = useState([]);
  const {mutateAsync} = useMutation(Authorization.spaceAccess);
  const {push} = useHistory();
  const [search, setSearch] = useState('');
  const {isMobile} = useResponsive();
  
  const handleSearch = useCallback((value) => {
    setSearch(value?.target?.value?.toLowerCase());
  }, []);

  const handleOpenChange = useCallback(() => {
    setSearch('');
  }, []);
  
  const filterSpaces = useMemo(() => (
    spaceList?.filter(space => space?.name?.toLowerCase().includes(search))
  ), [spaceList, search]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    !isLoading && data && setSpaceList(data);
  }, [data, isLoading]);

  const handleClickItem = useCallback(async (space) => {
    const data = await mutateAsync(space?.id);
    push({pathname: '/impersonate', state: {token: data?.accessToken, space: space?.identifier}});
  }, [mutateAsync, push]);

  const menu = useMemo(() => (
    <div className={ classNames('ml-4 min-w-64 justify-center fixed', style.wrapperMenu) }>
      <Menu className={ classNames('min-w-64', style.shadowBox, style.noPaddingBottom, 'customMenu') }      >
        <Menu.ItemGroup className={ 'w-full h-full justify-items-center items-center' }
          title={ !isMobile && mini && t('changeStructure') }>
          <Input.Search value={search} className='pb-2' onChange={ handleSearch } />
          {
            filterSpaces?.length &&
            <Scrollbars
              renderTrackHorizontal={ props => <div { ...props } style={ { display: 'none' } } className="track-horizontal" /> }
              autoHide
              autoHeight
              autoHeightMax={ 600 }
            >
              <div className='max-h-48 w-full custom-wrapper-scroll'>
                { filterSpaces?.map((el, i) =>
                  <Menu.Item
                    className={ classNames('mb-2 m-0 w-full h-auto flex justify-center items-center max-w-64 whitespace-normal custom-item-li', style.menuNotCollapsed) }
                    onClick={ () => handleClickItem(el) } key={ `space-${i}` }>
                    <SpaceAvatar space={ el } className={ 'mr-2' } shape="circle" size={ 32 } />
                    <div className="items-center justify-center flex flex-wrap" style={ { maxWidth: '190px', lineHeight: '16px' } }>
                      <h3 className="m-0 p-0 block text-xs space-item-text">{ el?.name }</h3>
                    </div> 
                  </Menu.Item>) }
              </div>
            </Scrollbars> ||
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{margin:15}}/>
          }
        </Menu.ItemGroup>
      </Menu>
    </div>
  ), [handleClickItem, mini, filterSpaces, t, handleSearch, search, isMobile]);

  const content = useMemo(() => (
    <div className={classNames('p-2 flex justify-items-center items-center text-black', style.dropdownColor)}>
      <SpaceAvatar space={space} className="mr-3" size={32}/>
      <div className="text-xs justify-items-center items-center">
        <h3 className="m-0 leading-none text-black text-sm">{space?.name}</h3>
        {/*<span className="leading-none text-xs opacity-75">{space?.email}</span>*/}
      </div>
      <CaretRightOutlined className={'mr-2 ml-auto text-xs'} hidden={spaceList?.length < 2}/>
    </div>
  ), [space, spaceList]);

  const contentMini = useMemo(() => (
    <div className={'text-white flex items-center justify-center'}>
      <SpaceAvatar space={space} className={'p-auto'} size="default"/>
    </div>
  ), [space]);

  if (spaceList?.length === 0) {
    return (
      <div className="cursor-default">
        {mini ? contentMini : space?.name === 'ROOT_SPACE' ? null : content}
      </div>
    );
  }

  return (
    <Dropdown
      overlayClassName={classNames('justify-items-center', !isMobile && (!mini ? style.leftPosition : style.leftPositionMini))}
      overlay={menu}
      getPopupContainer={() => document.getElementById('scroll-bars')}
      placement={(isMobile && 'bottomLeft') || ( mini ? 'topCenter' : 'topRight')}
      trigger={['click']}
      onOpenChange={ handleOpenChange }
    >
      <div className="px-4 py-2">
        <div
          className={classNames('flex items-start justify-center w-full text-black flex-col', style.structureWrapper)}>
          <div className="w-full">
            {!mini && t('changeStructure')}
          </div>

          <div className="w-full">
            <a className="ant-dropdown-link">
              {mini ? contentMini : content}
              {/*<Divider className="m-0 bg-primary-1"/>*/}
            </a>
          </div>
        </div>
      </div>

    </Dropdown>);
};

HeaderMenu.propTypes = {
  mini: PropTypes.any,
  mode: PropTypes.string,
  theme: PropTypes.string,
};

export default HeaderMenu;
